"use client"

import { DDOPTrackPage } from "@repo/shared"
import { usePathname, useSearchParams } from "next/navigation" // 1. 引入这两个 Hook
import { Suspense, useEffect } from "react"

/**
 * 内部实际执行埋点的组件
 */
const PageTrackerEvents = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    // 3. 当 pathname 或 searchParams 变化时，重新触发埋点
    // 建议：如果你需要在埋点中传参，可以在这里获取完整 URL
    // const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '')

    void DDOPTrackPage()
  }, [pathname, searchParams]) // 依赖项必须包含这两个

  return null
}

/**
 * 页面级统计埋点组件
 * 4. 必须包裹在 Suspense 中，因为 useSearchParams 会导致组件在构建时退化
 */
const PageTracker = () => {
  return (
    <Suspense fallback={null}>
      <PageTrackerEvents />
    </Suspense>
  )
}

export default PageTracker
